import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { API } from "../constants/config";

const GD = "#064E3B";
const TRADITIONS = ["全部","噶举","宁玛","格鲁","萨迦","汉传","南传","其他"];

export default function TemplesListPage({ setPage }) {
  const [temples, setTemples]     = useState([]);
  const [total, setTotal]         = useState(0);
  const [tab, setTab]             = useState("全部");
  const [search, setSearch]       = useState("");
  const [page, setPageNum]        = useState(1);
  const [loading, setLoading]     = useState(true);
  const PER_PAGE = 30;

  const load = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams({ page, per_page: PER_PAGE });
    if (tab !== "全部") params.set("tradition", tab);
    if (search.trim()) params.set("q", search.trim());
    fetch(`${API}/vajra/temples?${params}`)
      .then(r => r.ok ? r.json() : { temples: [], total: 0 })
      .then(d => { setTemples(d.temples || []); setTotal(d.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [tab, search, page]);

  useEffect(() => { setPageNum(1); }, [tab, search]);
  useEffect(() => { load(); }, [load]);

  const totalPages = Math.ceil(total / PER_PAGE);

  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: "32px 16px", minHeight: "70vh" }}>
      <div style={{marginBottom:4}}>
        <Link to="/vajra" style={{fontSize:12,color:"#8B6914",textDecoration:"none"}}>如意宝金刚社群</Link>
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: GD, marginBottom: 4 }}>寺院供养名录</h1>
      <p style={{ fontSize: 13, color: "#6b5c3e", marginBottom: 24 }}>护持正法道场 · Support Dharma Temples</p>

      {/* Search */}
      <input value={search} onChange={e => setSearch(e.target.value)}
        placeholder="搜索寺院名…"
        style={{ width: "100%", maxWidth: 320, padding: "8px 12px", border: "1px solid rgba(6,78,59,0.2)", borderRadius: 8, fontSize: 13, marginBottom: 16, boxSizing: "border-box" }} />

      {/* Tradition tabs */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
        {TRADITIONS.map(t => (
          <button key={t} onClick={() => setTab(t)}
            style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, cursor: "pointer", border: tab === t ? "none" : "1px solid rgba(6,78,59,0.2)", background: tab === t ? GD : "transparent", color: tab === t ? "#fff" : GD }}>
            {t}
          </button>
        ))}
      </div>

      {loading && <div style={{ textAlign: "center", color: "#9ca3af", paddingTop: 60 }}>加载中…</div>}

      {!loading && temples.length === 0 && (
        <div style={{ textAlign: "center", color: "#9ca3af", paddingTop: 60 }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>☸</div>
          暂无寺院记录
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 16 }}>
        {temples.map(t => <TempleCard key={t.id} t={t} />)}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 28 }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <button key={p} onClick={() => setPageNum(p)}
              style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid rgba(6,78,59,0.2)", background: p === page ? GD : "transparent", color: p === page ? "#fff" : GD, cursor: "pointer", fontSize: 13 }}>
              {p}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function TempleCard({ t }) {
  return (
    <Link to={`/vajra/temples/${t.id}`} style={{ textDecoration: "none" }}>
      <div style={{ borderRadius: 10, border: "1px solid rgba(6,78,59,0.12)", background: "#fff", overflow: "hidden", transition: "box-shadow 0.2s" }}>
        {t.photo_url
          ? <img src={t.photo_url} alt={t.name_zh} style={{ width: "100%", height: 140, objectFit: "cover" }} />
          : <div style={{ height: 80, background: "linear-gradient(135deg,#064E3B,#10b981)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, opacity: 0.5 }}>☸</div>}
        <div style={{ padding: "12px 14px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{t.name_zh}</div>
          {t.name_en && <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>{t.name_en}</div>}
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {t.tradition && <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "rgba(6,78,59,0.08)", color: GD }}>{t.tradition}</span>}
            {t.location && <span style={{ fontSize: 11, color: "#6b7280" }}>📍 {t.location}</span>}
          </div>
          {t.primary_teacher && <div style={{ fontSize: 11, color: "#6b5c3e", marginTop: 6 }}>🪷 {t.primary_teacher.name_zh}</div>}
        </div>
      </div>
    </Link>
  );
}
